import Tabs from './Tabs'

export { default as Nav } from './TabNav'
export { default as Content } from './TabContent'
export { default as Item } from './TabItem'

export default Tabs
